import { destroy, get, post, put } from './client';

/**
 * 
 * 
 * @returns 
 */
export function getStores() {
    return get('stores')
}

/**
 * 
 * 
 * @returns 
 */
export function getMerchantStores() {
    return get('stores/merchant')
}

/**
 * 
 * @param {*} id 
 * @returns 
 */
export function getOneStore(id) {
    return get('store/' + id)
}

/**
 * 
 * @param {*} id 
 * @returns 
 */
export function deleteStore(id) {
    return destroy('store/' + id)
}

/**
 * 
 * @param {*} data 
 * @returns 
 */
export function saveStore(data) {
    return post('store', data)
}

/**
 * 
 * @param {*} data 
 * @returns 
 */
export function updateStore(data) {
    return put('store', data)
}
